import { useEffect } from 'react';

let jsrsasign = null;

async function loadJsrsasign() {
  if (!jsrsasign) {
    const module = await import('jsrsasign');
    jsrsasign = module.default;
  }
  return jsrsasign;
}

async function validate(content, signature, publicKeyString) {
  if (!content) {
    return false;
  }

  const rs = await loadJsrsasign();
  const publicKey = rs.KEYUTIL.getKey(publicKeyString);

  return publicKey.verify(content, signature);
}

function hexToString(hexx) {
  const hex = hexx.toString();
  let str = '';

  for (let i = 0, length = hex.length; i < length; i += 2) {
    str += String.fromCharCode(parseInt(hex.substr(i, 2), 16));
  }

  return decodeURIComponent(escape(str));
}

async function isValidScript(embeddedScript, scriptSignature, publicKey) {
  if (!publicKey || !scriptSignature) {
    return false;
  }

  return await validate(embeddedScript, scriptSignature, publicKey);
}

function execute(script) {
  // biome-ignore lint/security/noGlobalEval: no explanation
  eval(script);

  window.loadPaymentScript('payment');
}

async function init(code, scriptSignature, publicKey) {
  let codeToRun;

  try {
    codeToRun = JSON.parse(hexToString(code));
  } catch (_error) {
    return;
  }

  const { js: script } = codeToRun;

  if (await isValidScript(code, scriptSignature, publicKey)) {
    execute(script);
  }
}

export function useInstructionsScript({
  embeddedScript,
  scriptSignature,
  publicKey,
}) {
  useEffect(() => {
    if (embeddedScript && scriptSignature && publicKey) {
      const initializeScript = async () => {
        try {
          await init(embeddedScript.value, scriptSignature.value, publicKey);
        } catch (error) {
          console.error('Failed to initialize script:', error);
        }
      };

      initializeScript();
    }
  }, [embeddedScript, scriptSignature, publicKey]);
}
